import React, { HTMLAttributes, useState } from 'react';
import { DatePicker } from 'antd';
import { FormattedMessage } from 'react-intl';
import styles from './styles';

const datePicker = (props: any) => {
  let style = props.style;
  if (props.disabled) {
    style = { ...props.style, ...styles.disabled };
  }
  return (
    <DatePicker
      style={props.style ? props.style : style}
      id={props.id}
      disabled={props.disabled}
      disabledDate={props.disabledDate}
      format={props.format}
      {...props}
    />
  );
};

const datePickerWithPlaceholder = (props: any) => {
  let style = props.style;
  if (props.disabled) {
    style = { ...props.style, ...styles.disabled };
  }
  return (
    <FormattedMessage id={props.placeholder}>
      {(p: any) => <DatePicker
        style={props.style ? props.style : style}
        {...props}
        placeholder={p}
        id={props.id}
        disabled={props.disabled}
        disabledDate={props.disabledDate}
        format={props.format}
      />
      }
    </FormattedMessage>
  );
};

type OutlinedDatePickerProps = HTMLAttributes<HTMLInputElement> & {
  disabled?: boolean;
  disabledDate?: (date: any) => boolean;
  format?: string | string[]
}
const OutlinedDatePicker = (props: any) => {
  const [focus, setFocus] = useState(false);
  const isOccupied = focus || props.value;
  let labelStyle: any = isOccupied ? {...styles.outlinedPlaceholder, ...styles.outlinedLabel } : {...styles.outlinedPlaceholder}
  if (isOccupied) {
    const bgColor = isOccupied && props.disabled ? styles.outlinedGradientLinear : styles.outlinedWhiteBg
    labelStyle = {...labelStyle, ...bgColor}
  }


  let style = props.style;
  if (props.disabled) {
    style = { ...props.style, ...styles.disabled };
  }
  return (
    <div onFocus={() => setFocus(true)} onBlur={() => setFocus(false)} style={{position: 'relative'}}>
      <DatePicker
        picker='date'
        placeholder=''
        style={props.style ? props.style : style}
        id={props.id}
        disabled={props.disabled}
        disabledDate={props.disabledDate}
        format={props.format}
        {...props}
      />
      <label style={labelStyle}>{props.label}</label>
    </div>
  )
}

export const RBHDatepicker = (props: any) => {
  if (props.variant === 'outlined') {
    return OutlinedDatePicker(props);
  }

  if (props.placeholder) {
    return datePickerWithPlaceholder(props);
  }

  return datePicker(props);
};

export default RBHDatepicker;
